import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-gutter-md status-selector" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" No results ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_select, {
      modelValue: _ctx.equipmentDetails,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.equipmentDetails) = $event)),
      outlined: "",
      "use-input": "",
      clearable: "",
      "input-debounce": "0",
      "option-label": 
        (equipment) =>
          Object(equipment) === equipment && 'name' in equipment.equipmentModel
            ? equipment.equipmentModel.name +
              (equipment.tag ? '-' + equipment.tag : '')
            : ''
      ,
      options: _ctx.equipmentSearch,
      class: "main-dropdown",
      behavior: "menu",
      dense: "",
      onFilter: _ctx.filterEquipments
    }, {
      "no-option": _withCtx(() => [
        _createVNode(_component_q_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { class: "text-grey" }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue", "option-label", "options", "onFilter"])
  ]))
}